/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

require('./vendor/css3-animate-it');

require('./vendor/jquery.fancybox.min');

window.Fresco = require('./vendor/fresco');

window.AOS = require('./vendor/aos.min');

window.MarkerClusterer = require('marker-clusterer-plus');
window.bootstrapSelect = require('bootstrap-select');
window.parsley = require('parsleyjs');
window.slickCarousel = require('slick-carousel');
window.select2 = require('select2');
window.alertify = require('alertify.js');
window.jqueryPlaceholder = require('jquery-placeholder');
window.jqueryNiceSelect = require('jquery-nice-select');

require('./ai/variables');
require('./ai/property-map');
require('./ai/map-box');
require('./ai/shortlists');
require('./ai/form');
require('./ai/misc');
require('./ai/street-view');
require('./ai/download-files');
require('./ai/video')


// WEBPACK FOOTER //
// ./resources/assets/js/app.js